import { render, staticRenderFns } from "./Outdoor.vue?vue&type=template&id=8b498af0"
import script from "./Outdoor.vue?vue&type=script&lang=js"
export * from "./Outdoor.vue?vue&type=script&lang=js"
import style0 from "./Outdoor.vue?vue&type=style&index=0&id=8b498af0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports